import React, { useEffect, useState } from "react";
import "./attendence.css";

const API = "https://bodhimaram.onrender.com/api";
const IMAGE_PATH = "https://bodhimaram.onrender.com/uploads/students";

/* ---- ICONS ---- */
const CalendarCheckIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <path d="M16 2v4M8 2v4M3 10h18" />
    <path d="m9 16 2 2 4-4" />
  </svg>
);
const UsersIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);
const CheckCircleIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="m9 12 2 2 4-4" />
  </svg>
);
const XCircleIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="m15 9-6 6M9 9l6 6" />
  </svg>
);
const EditIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M17 3a2.85 2.85 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
  </svg>
);
const PlusIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 5v14M5 12h14" />
  </svg>
);
const HistoryIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 3v5h5" />
    <path d="M3.05 13A9 9 0 1 0 6 5.3L3 8" />
    <path d="M12 7v5l4 2" />
  </svg>
);
const SearchIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="11" cy="11" r="8" />
    <path d="m21 21-4.3-4.3" />
  </svg>
);
const CloseIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M18 6 6 18M6 6l12 12" />
  </svg>
);
const SaveIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2Z" />
    <path d="M17 21v-8H7v8M7 3v5h8" />
  </svg>
);
/* ---------------- */

const AttendancePage = ({groupCode}) => {
  const today = new Date().toISOString().split("T")[0];
  // const groupCode = "group20";
  const [selectedDate, setSelectedDate] = useState(today);
  const [students, setStudents] = useState([]);
  const [attendanceList, setAttendanceList] = useState([]);
  const [currentAttendance, setCurrentAttendance] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const formatDate = (d) => new Date(d).toLocaleDateString("en-CA");

  const getDateParts = (d) => {
    const dt = new Date(d);
    return {
      day: dt.getDate().toString().padStart(2, "0"),
      month: dt.toLocaleString("en-US", { month: "short" }).toUpperCase(),
      year: dt.getFullYear(),
    };
  };

  /* FETCH STUDENTS */
  useEffect(() => {
    if (!groupCode) return;
    fetch(`${API}/students/${groupCode}`)
      .then((res) => res.json())
      .then((data) => {
        setStudents(
          Array.isArray(data)
            ? data.map((stu) => ({
                student_id: stu.st_id,
                name: stu.childname,
                student_image: stu.student_image || null,
                status: "P",
              }))
            : [],
        );
      });
  }, [groupCode]);

  /* FETCH SUMMARY */
  const loadSummary = async () => {
    const res = await fetch(`${API}/attendance/summary/${groupCode}`);
    const data = await res.json();
    setAttendanceList(Array.isArray(data) ? data : []);
  };

  useEffect(() => {
    if (groupCode) loadSummary();
  }, [groupCode]);

  /* FETCH ATTENDANCE BY DATE */
  const fetchAttendanceByDate = async (date) => {
    const res = await fetch(`${API}/attendance/${groupCode}/${date}`);
    const data = await res.json();

    if (Array.isArray(data) && data.length) {
      setCurrentAttendance(
        students.map((stu) => {
          const found = data.find((a) => a.student_id === stu.student_id);
          return { ...stu, status: found ? found.status : "P" };
        }),
      );
      return true;
    }
    return false;
  };

  /* OPEN MODAL */
  const openAttendance = async (date) => {
    const cleanDate = formatDate(date);
    setSelectedDate(cleanDate);
    setSearchTerm("");

    const exists = await fetchAttendanceByDate(cleanDate);
    if (!exists) setCurrentAttendance(students.map((s) => ({ ...s })));

    setShowModal(true);
  };

  /* TOGGLE STATUS (coin flip) */
  const toggleStatus = (studentId) => {
    setCurrentAttendance((prev) =>
      prev.map((s) =>
        s.student_id === studentId
          ? { ...s, status: s.status === "P" ? "A" : "P" }
          : s,
      ),
    );
  };

  /* SAVE */
  const saveAttendance = async () => {
    const res = await fetch(`${API}/attendance`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        groupCode,
        date: selectedDate,
        attendance: currentAttendance.map((s) => ({
          student_id: s.student_id,
          status: s.status,
        })),
      }),
    });

    if (res.ok) {
      await loadSummary();
      setShowModal(false);
    } else {
      alert("Attendance save failed");
    }
  };

  const filteredAttendance = currentAttendance.filter((stu) =>
    stu.name?.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <div className="sgAtt_card">
      {/* TOP BAR */}
      <div className="sgAtt_topbar">
        <div className="sgAtt_dateWrap">
          <label className="sgAtt_dateLabel">Select Date</label>
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            className="sgAtt_date"
          />
        </div>

        <button
          className="sgAtt_addBtn"
          onClick={() => openAttendance(selectedDate)}
        >
          <PlusIcon /> <span>Add Attendance</span>
        </button>
      </div>

      {/* MOBILE-ONLY SECTION TITLE */}
      <div className="sgAtt_historyHeader">
        <HistoryIcon />
        <span>Attendance History</span>
      </div>

      {/* SUMMARY TABLE */}
      <div className="sgAtt_tableWrap">
        <div className="sgAtt_tableHead">
          <span>#</span>
          <span>Date</span>
          <span>Total</span>
          <span>Present</span>
          <span>Absent</span>
          <span>Action</span>
        </div>

        {attendanceList.length === 0 && (
          <div className="sgAtt_empty">No attendance records</div>
        )}

        {attendanceList.map((a, i) => {
          const { day, month, year } = getDateParts(a.date);
          return (
            <div key={a.date} className="sgAtt_tableRow">
              {/* ---- DESKTOP CELLS ---- */}
              <span className="sgAtt_cellIndex">{i + 1}</span>
              <span className="sgAtt_cellDate">{formatDate(a.date)}</span>
              <span className="sgAtt_cellTotal">{a.total}</span>
              <span className="sgAtt_cellPresent sgAtt_present">
                {a.present}
              </span>
              <span className="sgAtt_cellAbsent sgAtt_absent">{a.absent}</span>
              <button
                className="sgAtt_editBtn"
                onClick={() => openAttendance(a.date)}
              >
                Edit
              </button>

              {/* ---- MOBILE CARD ---- */}
              <div className="sgAtt_mobileCard">
                <div className="sgAtt_dateBadge">
                  <CalendarCheckIcon />
                  <span className="sgAtt_badgeDay">{day}</span>
                  <span className="sgAtt_badgeMonth">{month}</span>
                  <span className="sgAtt_badgeYear">{year}</span>
                </div>

                <div className="sgAtt_cardBody">
                  <div className="sgAtt_cardHeader">
                    {/* <span className="sgAtt_cardDate">{formatDate(a.date)}</span> */}
                    <button
                      className="sgAtt_editBtnMobile"
                      onClick={() => openAttendance(a.date)}
                    >
                      <EditIcon /> 
                    </button>
                  </div>

                  <div className="sgAtt_cardStats">
                    <div className="sgAtt_statItem">
                      <span className="sgAtt_statLabel">Total</span>
                      <span className="sgAtt_statValue">
                        <UsersIcon /> {a.total}
                      </span>
                    </div>
                    <div className="sgAtt_statItem">
                      <span className="sgAtt_statLabel">Present</span>
                      <span className="sgAtt_statValue sgAtt_present">
                        <CheckCircleIcon /> {a.present}
                      </span>
                    </div>
                    <div className="sgAtt_statItem">
                      <span className="sgAtt_statLabel">Absent</span>
                      <span className="sgAtt_statValue sgAtt_absent">
                        <XCircleIcon /> {a.absent}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* MODAL — Professional style */}
      {showModal && (
        <div className="sgAtt_modalOverlay">
          <div className="sgAtt_modal">
            <div className="sgAtt_modalGrip"></div>

            {/* HEADER */}
            <div className="sgAtt_modalHead">
              <div>
                <h3>Attendance</h3>
                <span className="sgAtt_modalSubDate">{selectedDate}</span>
              </div>
              <button
                className="sgAtt_closeBtn"
                onClick={() => setShowModal(false)}
              >
                <CloseIcon />
              </button>
            </div>

            {/* LIVE SUMMARY */}
            <div className="sgAtt_modalSummary">
              <div className="sgAtt_summaryChip sgAtt_chipTotal">
                <UsersIcon />
                <span>{currentAttendance.length}</span>
                <small>Total</small>
              </div>
              <div className="sgAtt_summaryChip sgAtt_chipPresent">
                <CheckCircleIcon />
                <span>
                  {currentAttendance.filter((s) => s.status === "P").length}
                </span>
                <small>Present</small>
              </div>
              <div className="sgAtt_summaryChip sgAtt_chipAbsent">
                <XCircleIcon />
                <span>
                  {currentAttendance.filter((s) => s.status === "A").length}
                </span>
                <small>Absent</small>
              </div>
            </div>

            {/* SEARCH */}
            <div className="sgAtt_searchWrap">
              <SearchIcon />
              <input
                type="text"
                placeholder="Search student..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="sgAtt_searchInput"
              />
            </div>

            {/* STUDENT LIST */}
            <div className="sgAtt_studentList">
              {filteredAttendance.length === 0 && (
                <div className="sgAtt_empty">No students found</div>
              )}

              {filteredAttendance.map((stu) => (
                <div key={stu.student_id} className="sgAtt_studentRow">
                  <div
                    className={`sgAtt_avatarRing ${stu.status === "A" ? "ring_absent" : "ring_present"}`}
                  >
                    {stu.student_image ? (
                      <img
                        src={`${IMAGE_PATH}/${stu.student_image}`}
                        alt={stu.name}
                      />
                    ) : (
                      <div className="sgAtt_avatarFallback">
                        {stu.name?.charAt(0).toUpperCase()}
                      </div>
                    )}
                  </div>

                  <div className="sgAtt_studentInfo">
                    <span className="sgAtt_studentName">{stu.name}</span>
                    <span
                      className={`sgAtt_statusTag ${stu.status === "A" ? "tag_absent" : "tag_present"}`}
                    >
                      {stu.status === "A" ? "Absent" : "Present"}
                    </span>
                  </div>

                  {/* COIN FLIP TOGGLE */}
                  <button
                    className={`sgAtt_coin ${stu.status === "A" ? "is_absent" : ""}`}
                    onClick={() => toggleStatus(stu.student_id)}
                    aria-label={`Toggle attendance for ${stu.name}`}
                  >
                    <div className="sgAtt_coinInner">
                      <div className="sgAtt_coinFace sgAtt_coinFront">P</div>
                      <div className="sgAtt_coinFace sgAtt_coinBack">A</div>
                    </div>
                  </button>
                </div>
              ))}
            </div>

            {/* FOOTER */}
            <div className="sgAtt_modalActions">
              <button
                className="sgAtt_btnSecondary"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>
              <button className="sgAtt_btnPrimary" onClick={saveAttendance}>
                <SaveIcon /> <span>Save Attendance</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AttendancePage;
